import { connect } from 'react-redux';
import { IState } from '../../../store';

import {
  BuildingGarageLandCard,
  IBuildingGarageLandCardProps,
  IBuildingGarageLandCardStoreProps,
} from './buildingGarageLand';

function mapStateToProps(state: IState): IBuildingGarageLandCardStoreProps {
  const {
    experiments,
    isStalkerBannerShown,
    isBrandingAvailable,
    hideOffer: {
      status,
      errorMessage,
      isTopPopupOpened,
    },
    offerData: {
      offer,
      user,
      isHiddenByUser,
    },
  } = state;

  return {
    experiments,
    offer,
    isUserAuthenticated: user && user.isAuthenticated,
    isStalkerBannerShown,
    isBrandingAvailable,
    hideOfferStatus: status,
    hideOfferErrorMessage: errorMessage,
    isTopPopupOpened,
    isHiddenByUser,
  };
}

export const BuildingGarageLandCardContainer = connect<IBuildingGarageLandCardStoreProps,
  {},
  IBuildingGarageLandCardProps>(mapStateToProps)(BuildingGarageLandCard);
